import type { StatusBadgeTone } from '@shared/ui';

export type RegistrationPaymentStatusSource =
  | string
  | {
      dbValue?: string | null;
      display?: string | null;
    }
  | null
  | undefined;

function comparableValue(value: RegistrationPaymentStatusSource): string | null {
  if (typeof value === 'string') return value.trim() || null;
  return value?.dbValue?.trim() || value?.display?.trim() || null;
}

/** Maps only the Registration-owned registration_cost_status_os catalogue. */
export function getRegistrationPaymentStatusTone(
  value: RegistrationPaymentStatusSource
): StatusBadgeTone {
  switch (comparableValue(value)?.toLocaleLowerCase('en-US')) {
    case 'no cost':
    case 'paid':
      return 'positive';
    case 'unpaid':
      return 'warning';
    case 'refunded':
      return 'informational';
    default:
      return 'neutral';
  }
}

/** Keeps the display label owned by the Registration response unchanged. */
export function registrationPaymentStatusLabel(
  value: RegistrationPaymentStatusSource
): string | null {
  if (typeof value === 'string') return value.trim().length > 0 ? value : null;
  return value?.display?.trim().length ? value.display : null;
}
